var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _initialized, _Component_instances, updateRefs_fn, _mutationObserver, _isDescendant, _cache, _abortControllersBySectionId, _pendingPromises, _SectionRenderer_instances, abortPendingMorph_fn, cachePageSections_fn;
const requestIdleCallback$1 = typeof window.requestIdleCallback == "function" ? window.requestIdleCallback : setTimeout;
const isBot = !!(window.Shopify && window.Shopify.designMode);
let _interacted = false;
let _interactQueue = [];
let _interactTimer = setTimeout(_flushQueue, 8500);
const _triggerEvents = ["pointerdown", "pointermove", "scroll", "wheel", "keydown", "touchstart"];
function _flushQueue() {
  if (_interacted) return;
  _interacted = true;
  document.dispatchEvent(new CustomEvent("page:first-interaction", { bubbles: true }));
  clearTimeout(_interactTimer);
  _triggerEvents.forEach((evt) => window.removeEventListener(evt, _onFirstInteract));
  const fns = _interactQueue.splice(0);
  for (const fn of fns) {
    try {
      fn();
    } catch (e) {
    }
  }
}
function _markUserPresence() {
  requestAnimationFrame(() => {
    var _a, _b;
    if (!((_a = document.body) == null ? void 0 : _a.hasAttribute("data-user-presence"))) {
      (_b = document.body) == null ? void 0 : _b.setAttribute("data-user-presence", "");
    }
  });
}
function _onFirstInteract() {
  _markUserPresence();
  _flushQueue();
}
if (isBot) {
  requestAnimationFrame(_flushQueue);
} else if (typeof window !== "undefined") {
  _triggerEvents.forEach(
    (evt) => window.addEventListener(evt, _onFirstInteract, { once: true, passive: true })
  );
}
function onFirstInteraction(cb, safetyMs = 0) {
  if (_interacted) {
    cb();
    return;
  }
  _interactQueue.push(cb);
  if (!_interactTimer && safetyMs > 0) {
    _interactTimer = setTimeout(_flushQueue, safetyMs);
  }
}
function onFirstInteractionIdle(cb) {
  onFirstInteraction(() => requestIdleCallback$1(cb));
}
function hasInteracted() {
  return _interacted;
}
function activateInteractionAssets(root = document) {
  root.querySelectorAll('script[type="text/interaction-module"]').forEach((s) => {
    const fresh = document.createElement("script");
    fresh.type = "module";
    fresh.crossOrigin = "anonymous";
    if (s.dataset.src) fresh.src = s.dataset.src;
    if (s.innerHTML) fresh.innerHTML = s.innerHTML;
    document.body.appendChild(fresh);
    s.remove();
  });
  root.querySelectorAll('link[rel="interaction-modulepreload"]').forEach((l) => {
    l.rel = "modulepreload";
    if (l.dataset.href) l.href = l.dataset.href;
  });
  root.querySelectorAll('link[rel="interaction-stylesheet"]').forEach((l) => {
    l.rel = "stylesheet";
    if (l.dataset.href) l.href = l.dataset.href;
  });
}
onFirstInteraction(() => activateInteractionAssets(document), 0);
let _cachedFontSize = null;
if (typeof window !== "undefined") {
  requestAnimationFrame(() => {
    _cachedFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
  });
}
window.addEventListener("resize", () => {
  _cachedFontSize = null;
}, { passive: true });
function getBaseFontSize() {
  return _cachedFontSize ?? (_cachedFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize));
}
function remToPx(rem) {
  return rem * getBaseFontSize();
}
class ResizeNotifier extends ResizeObserver {
  constructor(callback) {
    super((entries) => {
      if (__privateGet(this, _initialized)) return callback(entries, this);
      __privateSet(this, _initialized, true);
    });
    __privateAdd(this, _initialized, false);
  }
  disconnect() {
    __privateSet(this, _initialized, false);
    super.disconnect();
  }
}
_initialized = new WeakMap();
function formatMoney(cents, format = "{{amount_no_decimals_with_comma_separator}}") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const defaultFormat = format || "{{amount}}";
  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
    if (isNaN(number) || number == null) return "0";
    number = (number / 100).toFixed(precision);
    const parts = number.split(".");
    const dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    const cents2 = parts[1] ? decimal + parts[1] : "";
    return dollars + cents2;
  }
  switch (defaultFormat.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }
  return defaultFormat.replace(placeholderRegex, value);
}
function fetchConfig(type = "json", config = {}) {
  const headers = { "Content-Type": "application/json", Accept: `application/${type}`, ...config.headers };
  if (type === "javascript") {
    headers["X-Requested-With"] = "XMLHttpRequest";
    delete headers["Content-Type"];
  }
  return {
    method: "POST",
    headers: (
      /** @type {HeadersInit} */
      headers
    ),
    body: config.body
  };
}
function debounce(fn, wait) {
  let timeout;
  function debounced(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), wait);
  }
  debounced.cancel = () => {
    clearTimeout(timeout);
  };
  return (
    /** @type {T & { cancel(): void }} */
    debounced
  );
}
function onAnimationEnd(elements, callback, options = { subtree: true }) {
  const animations = Array.isArray(elements) ? elements.flatMap((element) => element.getAnimations(options)) : elements.getAnimations(options);
  const animationPromises = animations.reduce(
    (acc, animation) => {
      if (animation.timeline instanceof DocumentTimeline) {
        acc.push(animation.finished);
      }
      return acc;
    },
    /** @type {Promise<Animation>[]} */
    []
  );
  return Promise.allSettled(animationPromises).then(callback);
}
function isClickedOutside(event, element) {
  if (event.target instanceof HTMLDialogElement || !(event.target instanceof Element) || event.target.getRootNode() !== document) {
    return !isPointWithinElement(event.clientX, event.clientY, element);
  }
  return !element.contains(event.target);
}
function isPointWithinElement(x, y, element) {
  const { left, right, top, bottom } = element.getBoundingClientRect();
  return x >= left && x <= right && y >= top && y <= bottom;
}
const reducedMotion = matchMedia("(prefers-reduced-motion: reduce)");
function prefersReducedMotion() {
  return reducedMotion.matches;
}
function resetShimmer(container = document.body) {
  if (!(container instanceof HTMLElement) || Shopify.designMode) {
    return;
  } else {
    const shimmer = container.querySelectorAll("[shimmer]");
    shimmer.forEach((item) => item.removeAttribute("shimmer"));
  }
}
class TextAnim extends HTMLElement {
  shimmer() {
    if (Shopify.designMode) return;
    this.setAttribute("shimmer", "");
  }
}
if (!customElements.get("text-anim")) {
  customElements.define("text-anim", TextAnim);
}
function onDocumentLoaded(callback) {
  if (document.readyState === "complete") {
    callback();
  } else {
    window.addEventListener("load", callback);
  }
}
function isMobile() {
  return window.matchMedia && window.matchMedia("(max-width: 991px)").matches;
}
function isTablet() {
  return window.matchMedia && window.matchMedia("(max-width: 991px)").matches && window.matchMedia("(min-width: 768px)").matches;
}
function isDesktop() {
  return window.matchMedia && window.matchMedia("(min-width: 992px)").matches;
}
function isTouchDevice() {
  return "ontouchstart" in window || navigator.maxTouchPoints > 0;
}
const _tpl = document.createElement("template");
function setInnerHTML(element, html) {
  _tpl.innerHTML = html;
  const frag = _tpl.content;
  for (const old of frag.querySelectorAll("script")) {
    const fresh = document.createElement("script");
    for (const attr of old.attributes) fresh.setAttribute(attr.name, attr.value);
    fresh.textContent = old.textContent;
    old.replaceWith(fresh);
  }
  if (hasInteracted()) {
    frag.querySelectorAll('link[rel="interaction-stylesheet"]').forEach((l) => {
      l.rel = "stylesheet";
      if (l.dataset.href) l.href = l.dataset.href;
    });
    frag.querySelectorAll('link[rel="interaction-modulepreload"]').forEach((l) => {
      l.rel = "modulepreload";
      if (l.dataset.href) l.href = l.dataset.href;
    });
  }
  element.replaceChildren(frag);
  if (hasInteracted()) {
    activateInteractionAssets(element);
  }
}
function setCookie(name, value, days = 30, path = "/") {
  const maxAge = days * 24 * 60 * 60;
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=${path}; max-age=${maxAge}`;
}
function getCookie(name) {
  const cookieArr = document.cookie.split("; ");
  for (let cookie of cookieArr) {
    const [key, val] = cookie.split("=");
    if (decodeURIComponent(key) === name) {
      return decodeURIComponent(val);
    }
  }
  return null;
}
const _jumboCTX = window.__jumboCTX ?? (window.__jumboCTX = document.createElement("canvas").getContext("2d"));
const _hasLetterSpacing = "letterSpacing" in _jumboCTX;
function findOptimalFontSize(text, containerWidth, computedStyle) {
  const { fontStyle, fontWeight, fontFamily, letterSpacing } = computedStyle;
  const baseFontSize = parseFloat(computedStyle.fontSize);
  const lsPx = parseFloat(letterSpacing) || 0;
  const lsRatio = baseFontSize ? lsPx / baseFontSize : 0;
  let minSize = 1, maxSize = 2e3;
  while (maxSize - minSize > 0.5) {
    const midSize = (minSize + maxSize) / 2;
    _jumboCTX.font = `${fontStyle} ${fontWeight} ${midSize}px ${fontFamily}`;
    if (_hasLetterSpacing) _jumboCTX.letterSpacing = `${lsRatio * midSize}px`;
    if (_jumboCTX.measureText(text).width > containerWidth) {
      maxSize = midSize;
    } else {
      minSize = midSize;
    }
  }
  return minSize * 0.99;
}
let _hasInteracted = false;
let _pendingBroadEntries = /* @__PURE__ */ new Set();
onFirstInteraction(() => {
  _hasInteracted = true;
  const elements = Array.from(_pendingBroadEntries);
  for (const el of elements) {
    const fn = _lazyCbs.get(el);
    if (fn) {
      _unobserveAll(el);
      setTimeout(() => {
        if (el.isConnected) fn();
      }, 0);
    }
  }
  _pendingBroadEntries.clear();
}, 0);
let _lazyIO_strict = null;
let _lazyIO_broad = null;
const _lazyCbs = /* @__PURE__ */ new WeakMap();
function _unobserveAll(el) {
  _lazyIO_strict == null ? void 0 : _lazyIO_strict.unobserve(el);
  _lazyIO_broad == null ? void 0 : _lazyIO_broad.unobserve(el);
  _pendingBroadEntries.delete(el);
  _lazyCbs.delete(el);
}
function lazyInit(el, cb, margin = "200% 0px") {
  if (!_lazyIO_strict) {
    _lazyIO_strict = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          const fn = _lazyCbs.get(entry.target);
          if (fn) {
            _unobserveAll(entry.target);
            setTimeout(() => {
              if (entry.target.isConnected) fn();
            }, 0);
          }
        }
      }
    }, { rootMargin: "10px 0px" });
    _lazyIO_broad = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          if (_hasInteracted) {
            const fn = _lazyCbs.get(entry.target);
            if (fn) {
              _unobserveAll(entry.target);
              setTimeout(() => {
                if (entry.target.isConnected) fn();
              }, 0);
            }
          } else {
            _pendingBroadEntries.add(entry.target);
          }
        } else {
          _pendingBroadEntries.delete(entry.target);
        }
      }
    }, { rootMargin: margin });
  }
  _lazyCbs.set(el, cb);
  _lazyIO_strict.observe(el);
  _lazyIO_broad.observe(el);
}
function onLazyLoad(e) {
  e.target.setAttribute("loaded", "");
  if (e.target.parentElement) e.target.parentElement.removeAttribute("data-lazy-loading");
}
function lazyReveal(scope = document) {
  const imgs = scope.querySelectorAll('img[loading="lazy"]:not([loaded])');
  if (!imgs.length) return;
  const toMark = [];
  const toWatch = [];
  for (const img of imgs) {
    if (img.complete && img.naturalWidth) toMark.push(img);
    else toWatch.push(img);
  }
  queueMicrotask(() => {
    for (const img of toMark) img.setAttribute("loaded", "");
    for (const img of toWatch) {
      if (img.parentElement) img.parentElement.setAttribute("data-lazy-loading", "");
      img.addEventListener("load", onLazyLoad, { once: true });
    }
  });
}
requestIdleCallback$1(() => lazyReveal());
const addTogglePrevNextBtnsActive = (emblaApi, prevBtn, nextBtn) => {
  let prevCanPrev = null;
  let prevCanNext = null;
  const togglePrevNextBtnsState = () => {
    const canPrev = emblaApi.canScrollPrev();
    const canNext = emblaApi.canScrollNext();
    if (canPrev === prevCanPrev && canNext === prevCanNext) return;
    prevCanPrev = canPrev;
    prevCanNext = canNext;
    prevBtn.toggleAttribute("disabled", !canPrev);
    nextBtn.toggleAttribute("disabled", !canNext);
  };
  emblaApi.on("select", togglePrevNextBtnsState).on("init", togglePrevNextBtnsState).on("reinit", togglePrevNextBtnsState);
  return () => {
    prevBtn.removeAttribute("disabled");
    nextBtn.removeAttribute("disabled");
  };
};
const addPrevNextBtnsClickHandlersSSR = (emblaApi, prevBtn, nextBtn) => {
  const scrollPrev = () => {
    var _a;
    emblaApi.scrollPrev();
    if ((_a = emblaApi.plugins()) == null ? void 0 : _a.autoplay) {
      requestAnimationFrame(() => {
        var _a2;
        (_a2 = emblaApi.plugins()) == null ? void 0 : _a2.autoplay.reset();
      });
    }
  };
  const scrollNext = () => {
    var _a;
    emblaApi.scrollNext();
    if ((_a = emblaApi.plugins()) == null ? void 0 : _a.autoplay) {
      requestAnimationFrame(() => {
        var _a2;
        (_a2 = emblaApi.plugins()) == null ? void 0 : _a2.autoplay.reset();
      });
    }
  };
  prevBtn.addEventListener("click", scrollPrev, false);
  nextBtn.addEventListener("click", scrollNext, false);
  const removeTogglePrevNextBtnsActive = addTogglePrevNextBtnsActive(
    emblaApi,
    prevBtn,
    nextBtn
  );
  return () => {
    removeTogglePrevNextBtnsActive();
    prevBtn.removeEventListener("click", scrollPrev, false);
    nextBtn.removeEventListener("click", scrollNext, false);
  };
};
const addInstagramDotBtnsAndClickHandlers = (emblaApi, dotsNode) => {
  let dotNodes = [];
  const addDotBtnsWithClickHandlers = () => {
    const dotCount = emblaApi.scrollSnapList().length;
    dotsNode.innerHTML = Array(dotCount).fill(0).map(
      (_, i) => `<button class="embla__dot${i === 0 ? " embla__dot--selected" : ""}" type="button" aria-label="Go to slide ${i + 1}"><div class="embla__dot-inner"></div></button>`
    ).join("");
    dotNodes = Array.from(dotsNode.querySelectorAll(".embla__dot"));
    dotNodes.forEach((dotNode, index) => {
      dotNode.addEventListener("click", () => emblaApi.scrollTo(index), false);
    });
  };
  const toggleDotBtnsActive = () => {
    const previous = emblaApi.previousScrollSnap();
    const selected = emblaApi.selectedScrollSnap();
    if (dotNodes[previous]) {
      dotNodes[previous].classList.remove("embla__dot--selected");
    }
    if (dotNodes[selected]) {
      dotNodes[selected].classList.add("embla__dot--selected");
    }
  };
  let isInitialized = false;
  emblaApi.on("init", addDotBtnsWithClickHandlers);
  emblaApi.on("reinit", addDotBtnsWithClickHandlers);
  const initSelect = () => {
    if (!isInitialized) {
      emblaApi.on("select", toggleDotBtnsActive);
      isInitialized = true;
    }
    toggleDotBtnsActive();
  };
  emblaApi.on("init", initSelect);
  addDotBtnsWithClickHandlers();
  initSelect();
  return () => {
    dotsNode.innerHTML = "";
  };
};
const addAutoplayProgressListeners = (emblaApi, getActiveBarNode) => {
  const updateProgress = () => {
    var _a;
    const autoplay = (_a = emblaApi == null ? void 0 : emblaApi.plugins()) == null ? void 0 : _a.autoplay;
    if (!autoplay) return;
    const barNode = getActiveBarNode();
    if (!barNode) return;
    const inner = barNode.querySelector(".embla__bar-inner");
    if (!inner) return;
    const timeUntilNext = autoplay.timeUntilNext();
    const delay = autoplay.options.delay;
    if (timeUntilNext === null) return;
    const progress = 1 - timeUntilNext / delay;
    inner.style.setProperty("--autoplay-progress", progress);
    requestAnimationFrame(updateProgress);
  };
  const resetProgress = () => {
    const barNode = getActiveBarNode();
    if (!barNode) return;
    const inner = barNode.querySelector(".embla__bar-inner");
    if (inner) {
      inner.style.setProperty("--autoplay-progress", 0);
    }
  };
  updateProgress();
  emblaApi.on("autoplay:timerset", updateProgress).on("autoplay:timerstopped", resetProgress).on("autoplay:reset", resetProgress);
  return () => {
    emblaApi.off("autoplay:timerset", updateProgress).off("autoplay:timerstopped", resetProgress);
  };
};
const addBarsBtnsAndClickHandlersSSR = (emblaApi, barsNode, originalSlideCount = null) => {
  let barNodes = [];
  let selectedNode = 0;
  let scrollHandlers = [];
  const getBarCount = () => originalSlideCount || barNodes.length || emblaApi.scrollSnapList().length;
  const setupClickHandlers = () => {
    var _a;
    barNodes.forEach((barNode, index) => {
      if (scrollHandlers[index]) {
        barNode.removeEventListener("click", scrollHandlers[index]);
      }
    });
    scrollHandlers = [];
    barNodes = Array.from(barsNode.querySelectorAll(".embla__bar"));
    const scrollTo = (index) => {
      var _a2;
      const autoplay2 = (_a2 = emblaApi.plugins()) == null ? void 0 : _a2.autoplay;
      emblaApi.scrollTo(index);
      requestAnimationFrame(() => {
        if (autoplay2) {
          autoplay2.reset();
        }
      });
    };
    barNodes.forEach((barNode, index) => {
      const handler = () => scrollTo(index);
      scrollHandlers.push(handler);
      barNode.addEventListener("click", handler);
    });
    const autoplay = (_a = emblaApi == null ? void 0 : emblaApi.plugins()) == null ? void 0 : _a.autoplay;
    if (autoplay) {
      barsNode.classList.add("autoplay");
      barsNode.classList.remove("non-autoplay");
      if (barNodes[selectedNode]) {
        barNodes[selectedNode].classList.add("embla__bar--selected");
      }
      addAutoplayProgressListeners(
        emblaApi,
        () => barNodes[selectedNode]
      );
    } else {
      barsNode.classList.add("non-autoplay");
      barsNode.classList.remove("autoplay");
    }
  };
  const toggleBarBtnsActive = () => {
    const selected = emblaApi.selectedScrollSnap();
    const previous = emblaApi.previousScrollSnap();
    const barCount = getBarCount();
    const mappedSelected = originalSlideCount ? selected % barCount : selected;
    const mappedPrevious = originalSlideCount ? previous % barCount : previous;
    if (barNodes[mappedPrevious]) {
      barNodes[mappedPrevious].classList.remove("embla__bar--selected");
    }
    if (barNodes[mappedSelected]) {
      barNodes[mappedSelected].classList.add("embla__bar--selected");
    }
    selectedNode = mappedSelected;
  };
  let isInitialized = false;
  emblaApi.on("init", setupClickHandlers);
  emblaApi.on("reinit", setupClickHandlers);
  const initSelect = () => {
    if (!isInitialized) {
      emblaApi.on("select", toggleBarBtnsActive);
      isInitialized = true;
    }
    toggleBarBtnsActive();
  };
  emblaApi.on("init", initSelect);
  setupClickHandlers();
  initSelect();
  return () => {
    barNodes.forEach((barNode, index) => {
      if (scrollHandlers[index]) {
        barNode.removeEventListener("click", scrollHandlers[index]);
      }
    });
    scrollHandlers = [];
  };
};
const addAutoplayProgressDotListeners = (emblaApi, getActiveBarNode) => {
  const updateProgress = () => {
    var _a;
    const autoplay = (_a = emblaApi == null ? void 0 : emblaApi.plugins()) == null ? void 0 : _a.autoplay;
    if (!autoplay) return;
    const barNode = getActiveBarNode();
    if (!barNode) return;
    const dot = barNode.querySelector(".embla__dot-inner, .embla__dot__inner");
    if (!dot) return;
    const timeUntilNext = autoplay.timeUntilNext();
    const delay = autoplay.options.delay;
    if (timeUntilNext === null) return;
    const progress = 1 - timeUntilNext / delay;
    dot.style.setProperty("--autoplay-progress", progress);
    requestAnimationFrame(updateProgress);
  };
  const resetProgress = () => {
    const barNode = getActiveBarNode();
    if (!barNode) return;
    const dot = barNode.querySelector(".embla__dot-inner, .embla__dot__inner");
    dot.style.setProperty("--autoplay-progress", 0);
  };
  updateProgress();
  emblaApi.on("autoplay:timerset", updateProgress).on("autoplay:timerstopped", resetProgress).on("autoplay:reset", resetProgress);
  return () => {
    emblaApi.off("autoplay:timerset", updateProgress).off("autoplay:timerstopped", resetProgress);
  };
};
const addDotsBtnsAndClickHandlersSSR = (emblaApi, dotsNode, originalSlideCount = null) => {
  let dotNodes = [];
  let selectedNode = 0;
  let scrollHandlers = [];
  const getDotCount = () => originalSlideCount || dotNodes.length || emblaApi.scrollSnapList().length;
  const setupClickHandlers = () => {
    var _a;
    dotNodes.forEach((dotNode, index) => {
      if (scrollHandlers[index]) {
        dotNode.removeEventListener("click", scrollHandlers[index]);
      }
    });
    scrollHandlers = [];
    dotNodes = Array.from(dotsNode.querySelectorAll(".embla__dot"));
    const scrollTo = (index) => {
      var _a2;
      const autoplay2 = (_a2 = emblaApi.plugins()) == null ? void 0 : _a2.autoplay;
      emblaApi.scrollTo(index);
      requestAnimationFrame(() => {
        if (autoplay2) {
          autoplay2.reset();
        }
      });
    };
    dotNodes.forEach((dotNode, index) => {
      const handler = () => scrollTo(index);
      scrollHandlers.push(handler);
      dotNode.addEventListener("click", handler);
    });
    const autoplay = (_a = emblaApi == null ? void 0 : emblaApi.plugins()) == null ? void 0 : _a.autoplay;
    if (autoplay) {
      dotsNode.classList.add("autoplay");
      dotsNode.classList.remove("non-autoplay");
      if (dotNodes[selectedNode]) {
        dotNodes[selectedNode].classList.add("embla__dot--selected");
      }
      addAutoplayProgressDotListeners(
        emblaApi,
        () => dotNodes[selectedNode]
      );
    } else {
      dotsNode.classList.add("non-autoplay");
      dotsNode.classList.remove("autoplay");
    }
  };
  const toggleDotBtnsActive = () => {
    const selected = emblaApi.selectedScrollSnap();
    const previous = emblaApi.previousScrollSnap();
    const dotCount = getDotCount();
    const mappedSelected = originalSlideCount ? selected % dotCount : selected;
    const mappedPrevious = originalSlideCount ? previous % dotCount : previous;
    if (dotNodes[mappedPrevious]) {
      dotNodes[mappedPrevious].classList.remove("embla__dot--selected");
    }
    if (dotNodes[mappedSelected]) {
      dotNodes[mappedSelected].classList.add("embla__dot--selected");
    }
    selectedNode = mappedSelected;
  };
  let isInitialized = false;
  emblaApi.on("init", setupClickHandlers);
  emblaApi.on("reinit", setupClickHandlers);
  const initSelect = () => {
    if (!isInitialized) {
      emblaApi.on("select", toggleDotBtnsActive);
      isInitialized = true;
    }
    toggleDotBtnsActive();
  };
  emblaApi.on("init", initSelect);
  setupClickHandlers();
  initSelect();
  return () => {
    dotNodes.forEach((dotNode, index) => {
      if (scrollHandlers[index]) {
        dotNode.removeEventListener("click", scrollHandlers[index]);
      }
    });
    scrollHandlers = [];
  };
};
const addLayoutShiftPrevention = (emblaApi, emblaWrapper) => {
  if (!emblaApi || !emblaWrapper) {
    return () => {
    };
  }
  const onInit = () => {
    var _a, _b;
    emblaWrapper.classList.add("is-initialized");
    if (emblaApi.slideNodes().length <= 1) {
      emblaWrapper.classList.add("is-single-slide");
      (_a = emblaApi.containerNode()) == null ? void 0 : _a.classList.add("is-single-slide");
    } else {
      emblaWrapper.classList.remove("is-single-slide");
      (_b = emblaApi.containerNode()) == null ? void 0 : _b.classList.remove("is-single-slide");
    }
  };
  const onDestroy = () => {
    var _a;
    emblaWrapper.classList.remove("is-initialized", "is-single-slide");
    (_a = emblaApi.containerNode()) == null ? void 0 : _a.classList.remove("is-single-slide");
  };
  emblaApi.on("init", onInit).on("reinit", onInit);
  return () => {
    emblaApi.off("init", onInit).off("reinit", onInit);
    onDestroy();
  };
};
const duplicateSlidesForLoop = (emblaApi, emblaContainer, maxIterations = 5) => {
  var _a, _b;
  const originalSlideCount = emblaContainer.children.length;
  if (!emblaApi || originalSlideCount === 0) return originalSlideCount;
  const rootNode = emblaApi.rootNode();
  const viewportWidth = rootNode.offsetWidth || window.innerWidth;
  const initialSlides = Array.from(emblaContainer.children);
  let totalSlideWidth = 0;
  for (const slide of initialSlides) {
    totalSlideWidth += slide.offsetWidth || 0;
  }
  let iterations = 0;
  const slidesToAppend = [];
  if (totalSlideWidth > 0 && viewportWidth > 0) {
    const requiredWidth = viewportWidth * 2;
    let currentWidth = totalSlideWidth;
    let currentVirtualSlides = [...initialSlides];
    while (currentWidth <= requiredWidth && iterations < maxIterations) {
      const newClones = [];
      currentVirtualSlides.forEach((slide) => {
        const clone = slide.cloneNode(true);
        clone.querySelectorAll("img").forEach((img) => {
          img.setAttribute("loaded", "");
          if (img.parentElement) img.parentElement.removeAttribute("data-lazy-loading");
        });
        newClones.push(clone);
      });
      slidesToAppend.push(...newClones);
      currentVirtualSlides = [...currentVirtualSlides, ...newClones];
      currentWidth *= 2;
      iterations++;
    }
  }
  if (slidesToAppend.length > 0) {
    const fragment = document.createDocumentFragment();
    slidesToAppend.forEach((slide) => fragment.appendChild(slide));
    emblaContainer.appendChild(fragment);
    emblaApi.reInit();
  }
  while (!((_b = (_a = emblaApi.internalEngine()) == null ? void 0 : _a.slideLooper) == null ? void 0 : _b.canLoop()) && iterations < maxIterations) {
    const currentSlidesForFallback = Array.from(emblaContainer.children);
    const fragment = document.createDocumentFragment();
    currentSlidesForFallback.forEach((slide) => {
      const clone = slide.cloneNode(true);
      clone.querySelectorAll("img").forEach((img) => {
        img.setAttribute("loaded", "");
        if (img.parentElement) img.parentElement.removeAttribute("data-lazy-loading");
      });
      fragment.appendChild(clone);
    });
    emblaContainer.appendChild(fragment);
    emblaApi.reInit();
    iterations++;
  }
  return originalSlideCount;
};
const extractSlideColorSchemes = (emblaContainer) => {
  const slides = Array.from(emblaContainer.children);
  const colorSchemes = slides.map((slide) => {
    const colorClass = Array.from(slide.classList).find((cls) => cls.startsWith("color-"));
    return colorClass || null;
  });
  return colorSchemes;
};
const addColorSchemeSyncHandlers = (emblaApi, paginationContainer, slideColorSchemes, originalSlideCount = null) => {
  if (!emblaApi || !paginationContainer || !slideColorSchemes || slideColorSchemes.length === 0) {
    return () => {
    };
  }
  let currentColorScheme = null;
  const updateColorScheme = () => {
    const selectedIndex = emblaApi.selectedScrollSnap();
    const originalIndex = originalSlideCount ? selectedIndex % originalSlideCount : selectedIndex;
    const newColorScheme = slideColorSchemes[originalIndex];
    if (newColorScheme === currentColorScheme) {
      return;
    }
    if (currentColorScheme) {
      paginationContainer.classList.remove(currentColorScheme);
    }
    if (newColorScheme) {
      paginationContainer.classList.add(newColorScheme);
    }
    currentColorScheme = newColorScheme;
  };
  emblaApi.on("init", updateColorScheme).on("reinit", updateColorScheme).on("select", updateColorScheme);
  return () => {
    emblaApi.off("init", updateColorScheme).off("reinit", updateColorScheme).off("select", updateColorScheme);
  };
};
const addNumberPagination = (emblaApi, paginationContainer) => {
  if (!emblaApi || !paginationContainer) {
    return () => {
    };
  }
  const currentEl = paginationContainer.querySelector(".embla__number-current");
  const totalEl = paginationContainer.querySelector(".embla__number-total");
  const prevBtn = paginationContainer.querySelector(".embla__number-nav--prev");
  const nextBtn = paginationContainer.querySelector(".embla__number-nav--next");
  if (!currentEl || !totalEl) {
    return () => {
    };
  }
  const updateNumbers = () => {
    const currentSlide = emblaApi.selectedScrollSnap() + 1;
    const totalSlides = emblaApi.scrollSnapList().length;
    currentEl.textContent = currentSlide;
    totalEl.textContent = totalSlides;
  };
  const toggleNavButtons = () => {
    if (prevBtn) {
      if (emblaApi.canScrollPrev()) {
        prevBtn.removeAttribute("disabled");
      } else {
        prevBtn.setAttribute("disabled", "disabled");
      }
    }
    if (nextBtn) {
      if (emblaApi.canScrollNext()) {
        nextBtn.removeAttribute("disabled");
      } else {
        nextBtn.setAttribute("disabled", "disabled");
      }
    }
  };
  const scrollPrev = () => emblaApi.scrollPrev();
  const scrollNext = () => emblaApi.scrollNext();
  if (prevBtn) prevBtn.addEventListener("click", scrollPrev);
  if (nextBtn) nextBtn.addEventListener("click", scrollNext);
  updateNumbers();
  toggleNavButtons();
  emblaApi.on("select", updateNumbers).on("select", toggleNavButtons).on("init", updateNumbers).on("init", toggleNavButtons).on("reinit", updateNumbers).on("reinit", toggleNavButtons);
  return () => {
    if (prevBtn) prevBtn.removeEventListener("click", scrollPrev);
    if (nextBtn) nextBtn.removeEventListener("click", scrollNext);
    emblaApi.off("select", updateNumbers).off("select", toggleNavButtons).off("init", updateNumbers).off("init", toggleNavButtons).off("reinit", updateNumbers).off("reinit", toggleNavButtons);
  };
};
const addThumbButtonClickHandlers = (emblaApiMain, emblaApiThumb) => {
  const slidesThumbs = emblaApiThumb.slideNodes();
  const scrollToIndex = slidesThumbs.map(
    (_, index) => () => emblaApiMain.scrollTo(index)
  );
  slidesThumbs.forEach((slideNode, index) => {
    slideNode.addEventListener("click", scrollToIndex[index], false);
  });
};
const addToggleThumbButtonsActive = (emblaApiMain, emblaApiThumb) => {
  const slidesThumbs = emblaApiThumb.slideNodes();
  const toggleThumbBtnsState = () => {
    emblaApiThumb.scrollTo(emblaApiMain.selectedScrollSnap());
    const previous = emblaApiMain.previousScrollSnap();
    const selected = emblaApiMain.selectedScrollSnap();
    slidesThumbs[previous].classList.remove("embla-thumbs__slide--selected");
    slidesThumbs[selected].classList.add("embla-thumbs__slide--selected");
  };
  emblaApiMain.on("select", toggleThumbBtnsState);
  toggleThumbBtnsState();
};
class DeclarativeShadowElement extends HTMLElement {
  connectedCallback() {
    if (!this.shadowRoot) {
      const template = this.querySelector(':scope > template[shadowrootmode="open"]');
      if (!(template instanceof HTMLTemplateElement)) return;
      const shadow = this.attachShadow({ mode: "open" });
      shadow.append(template.content.cloneNode(true));
    }
  }
}
class Component extends DeclarativeShadowElement {
  constructor() {
    super(...arguments);
    __privateAdd(this, _Component_instances);
    /**
     * An object holding references to child elements with `ref` attributes.
     *
     * @type {RefsType<T>}
     */
    __publicField(
      this,
      "refs",
      /** @type {RefsType<T>} */
      {}
    );
    /**
     * An array of required refs. If a ref is not found, an error will be thrown.
     *
     * @type {string[] | undefined}
     */
    __publicField(this, "requiredRefs");
    /**
     * MutationObserver instance to observe changes in the component's DOM subtree and update refs accordingly.
     *
     * @type {MutationObserver}
     */
    __privateAdd(this, _mutationObserver, new MutationObserver((mutations) => {
      if (mutations.some(
        (m) => m.type === "attributes" && __privateGet(this, _isDescendant).call(this, m.target) || m.type === "childList" && [...m.addedNodes, ...m.removedNodes].some(__privateGet(this, _isDescendant))
      )) {
        __privateMethod(this, _Component_instances, updateRefs_fn).call(this);
      }
    }));
    /**
     * Checks if a given node is a descendant of this component.
     *
     * @param {Node} node - The node to check.
     * @returns {boolean} True if the node is a descendant of this component.
     */
    __privateAdd(this, _isDescendant, (node) => getClosestComponent(getAncestor(node)) === this);
  }
  /**
   * Gets the root node of the component, which is either its shadow root or the component itself.
   *
   * @returns {(ShadowRoot | Component<T>)[]} The root nodes.
   */
  get roots() {
    return this.shadowRoot ? [this, this.shadowRoot] : [this];
  }
  /**
   * Called when the element is connected to the document's DOM.
   *
   * Initializes event listeners and refs.
   */
  connectedCallback() {
    super.connectedCallback();
    registerEventListeners();
    __privateMethod(this, _Component_instances, updateRefs_fn).call(this);
    requestIdleCallback$1(() => {
      for (const root of this.roots) {
        __privateGet(this, _mutationObserver).observe(root, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ["ref"],
          attributeOldValue: true
        });
      }
    });
  }
  /**
   * Called when the element is re-rendered by the Section Rendering API.
   */
  updatedCallback() {
    __privateGet(this, _mutationObserver).takeRecords();
    __privateMethod(this, _Component_instances, updateRefs_fn).call(this);
  }
  /**
   * Called when the element is disconnected from the document's DOM.
   *
   * Disconnects the mutation observer.
   */
  disconnectedCallback() {
    __privateGet(this, _mutationObserver).disconnect();
  }
}
_Component_instances = new WeakSet();
/**
 * Updates the `refs` object by querying all descendant elements with `ref` attributes and storing references to them.
 *
 * This method is called to keep the `refs` object in sync with the DOM.
 */
updateRefs_fn = function() {
  var _a;
  const refs = (
    /** @type any */
    {}
  );
  const elements = this.roots.reduce(
    (acc, root) => {
      for (const element of root.querySelectorAll("[ref]")) {
        if (!__privateGet(this, _isDescendant).call(this, element)) continue;
        acc.add(element);
      }
      return acc;
    },
    /** @type {Set<Element>} */
    /* @__PURE__ */ new Set()
  );
  for (const ref of elements) {
    const refName = ref.getAttribute("ref") ?? "";
    const isArray = refName.endsWith("[]");
    const path = isArray ? refName.slice(0, -2) : refName;
    if (isArray) {
      const array = Array.isArray(refs[path]) ? refs[path] : [];
      array.push(ref);
      refs[path] = array;
    } else {
      refs[path] = ref;
    }
  }
  if ((_a = this.requiredRefs) == null ? void 0 : _a.length) {
    for (const ref of this.requiredRefs) {
      if (!(ref in refs)) {
        throw new MissingRefError(ref, this);
      }
    }
  }
  this.refs = /** @type {RefsType<T>} */
  refs;
};
_mutationObserver = new WeakMap();
_isDescendant = new WeakMap();
function getAncestor(node) {
  if (node.parentNode) return node.parentNode;
  const root = node.getRootNode();
  if (root instanceof ShadowRoot) return root.host;
  return null;
}
function getClosestComponent(node) {
  if (!node) return null;
  if (node instanceof Component) return node;
  if (node instanceof HTMLElement && node.tagName.toLowerCase().endsWith("-component")) return node;
  const ancestor = getAncestor(node);
  if (ancestor) return getClosestComponent(ancestor);
  return null;
}
let initialized = false;
function registerEventListeners() {
  if (initialized) return;
  initialized = true;
  const events = ["click", "change", "select", "focus", "blur", "submit", "input", "keydown", "keyup", "toggle"];
  const shouldBubble = ["focus", "blur"];
  const expensiveEvents = ["pointerenter", "pointerleave"];
  for (const eventName of [...events, ...expensiveEvents]) {
    const attribute = `on:${eventName}`;
    document.addEventListener(
      eventName,
      (event) => {
        var _a;
        const element = getElement(event);
        if (!element) return;
        const proxiedEvent = event.target !== element ? new Proxy(event, {
          get(target, property) {
            if (property === "target") return element;
            const value2 = Reflect.get(target, property);
            if (typeof value2 === "function") {
              return value2.bind(target);
            }
            return value2;
          }
        }) : event;
        const value = element.getAttribute(attribute) ?? "";
        let [selector, method] = value.split("/");
        const data = (_a = value.match(new RegExp("(?<=[\\/\\?][^\\/\\?]+)[\\/\\?][^\\/\\?]+$"))) == null ? void 0 : _a[0];
        const instance = selector ? selector.startsWith("#") ? document.querySelector(selector) : element.closest(selector) : getClosestComponent(element);
        if (!(instance instanceof Component) || !method) return;
        method = method.replace(/\?.*/, "");
        const callback = (
          /** @type {any} */
          instance[method]
        );
        if (typeof callback === "function") {
          try {
            const args = [proxiedEvent];
            if (data) args.unshift(parseData(data));
            callback.call(instance, ...args);
          } catch (error) {
          }
        }
      },
      { capture: true }
    );
  }
  function getElement(event) {
    var _a;
    const target = ((_a = event.composedPath) == null ? void 0 : _a.call(event)[0]) ?? event.target;
    if (!(target instanceof Element)) return;
    if (target.hasAttribute(`on:${event.type}`)) {
      return target;
    }
    if (expensiveEvents.includes(event.type)) {
      return null;
    }
    return event.bubbles || shouldBubble.includes(event.type) ? target.closest(`[on\\:${event.type}]`) : null;
  }
}
function parseData(str) {
  const delimiter = str[0];
  const data = str.slice(1);
  return delimiter === "?" ? Object.fromEntries(
    Array.from(new URLSearchParams(data).entries()).map(([key, value]) => [key, parseValue(value)])
  ) : parseValue(data);
}
function parseValue(str) {
  if (str === "true") return true;
  if (str === "false") return false;
  const maybeNumber = Number(str);
  if (!isNaN(maybeNumber) && str.trim() !== "") return maybeNumber;
  return str;
}
class MissingRefError extends Error {
  /**
   * @param {string} ref
   * @param {Component} component
   */
  constructor(ref, component) {
    super(`Required ref "${ref}" not found in component ${component.tagName.toLowerCase()}`);
  }
}
const MORPH_OPTIONS = {
  childrenOnly: true,
  reject(oldNode, newNode) {
    var _a, _b;
    if (newNode.nodeType === Node.TEXT_NODE && ((_a = newNode.nodeValue) == null ? void 0 : _a.trim()) === "") {
      return true;
    }
    if (newNode instanceof HTMLTemplateElement && newNode.shadowRootMode === "open" && oldNode.parentElement && newNode.parentElement && oldNode.parentElement.tagName === newNode.parentElement.tagName && ((_b = oldNode.parentElement) == null ? void 0 : _b.shadowRoot) != null) {
      return true;
    }
    if (newNode.nodeType === Node.COMMENT_NODE && newNode.nodeValue === "shopify:rendered_by_section_api") {
      return true;
    }
    return false;
  },
  onBeforeUpdate(oldNode, newNode) {
    if (oldNode instanceof Element && newNode instanceof Element) {
      const attributes = ["product-grid-view"];
      for (const attribute of attributes) {
        const oldValue = oldNode.getAttribute(attribute);
        const newValue = newNode.getAttribute(attribute);
        if (oldValue && oldValue !== newValue) {
          newNode.setAttribute(attribute, oldValue);
        }
      }
      const elements = ["floating-panel-component"];
      for (const element of elements) {
        const tagName = element.toUpperCase();
        if (oldNode.tagName === tagName && newNode.tagName === tagName) {
          const oldStyle = oldNode.getAttribute("style");
          if (oldStyle) newNode.setAttribute("style", oldStyle);
        }
      }
      if (oldNode instanceof HTMLDetailsElement && newNode instanceof HTMLDetailsElement) {
        if (oldNode.closest("accordion-component")) {
          if (oldNode.open) {
            newNode.setAttribute("open", "");
          } else {
            newNode.removeAttribute("open");
          }
          if (oldNode.classList.contains("active")) {
            newNode.classList.add("active");
          } else {
            newNode.classList.remove("active");
          }
        }
      }
      if (oldNode.tagName === "FACETS-FORM-COMPONENT" && newNode.tagName === "FACETS-FORM-COMPONENT") {
        const oldFilterState = oldNode.getAttribute("data-filter");
        if (oldFilterState) {
          newNode.setAttribute("data-filter", oldFilterState);
        }
      }
      if (oldNode.classList.contains("filter-toggle") && newNode.classList.contains("filter-toggle")) {
        if (oldNode.classList.contains("active")) {
          newNode.classList.add("active");
        } else {
          newNode.classList.remove("active");
        }
      }
      if (oldNode instanceof HTMLElement && newNode instanceof HTMLElement && oldNode.style.viewTransitionName) {
        newNode.style.viewTransitionName = oldNode.style.viewTransitionName;
      }
    }
  },
  onAfterUpdate(node) {
    if (node instanceof Component) {
      queueMicrotask(() => node.updatedCallback());
    }
  }
};
function morph(oldTree, newTree, options = MORPH_OPTIONS) {
  if (!oldTree || !newTree) {
    throw new Error("Both oldTree and newTree must be provided");
  }
  if (typeof newTree === "string") {
    const parsedNewTree = new DOMParser().parseFromString(newTree, "text/html").body.firstChild;
    if (!parsedNewTree) {
      throw new Error("newTree string is not valid HTML");
    }
    newTree = parsedNewTree;
  }
  if (newTree.querySelectorAll && hasInteracted()) {
    newTree.querySelectorAll('link[rel="interaction-stylesheet"]').forEach((l) => {
      l.rel = "stylesheet";
      if (l.dataset.href) l.href = l.dataset.href;
    });
    newTree.querySelectorAll('link[rel="interaction-modulepreload"]').forEach((l) => {
      l.rel = "modulepreload";
      if (l.dataset.href) l.href = l.dataset.href;
    });
  }
  if (options.childrenOnly) {
    updateChildren(newTree, oldTree, options);
    return oldTree;
  }
  if (newTree.nodeType === 11) {
    throw new Error("newTree should have one root node (not a DocumentFragment)");
  }
  return walk(newTree, oldTree, options);
}
function walk(newNode, oldNode, options) {
  var _a, _b;
  if (!oldNode) return newNode;
  if (!newNode) return oldNode;
  if ((_a = newNode.isSameNode) == null ? void 0 : _a.call(newNode, oldNode)) return oldNode;
  if (newNode.nodeType !== oldNode.nodeType) return newNode;
  if (newNode instanceof Element && oldNode instanceof Element) {
    if (oldNode.tagName === "SHOPIFY-ACCELERATED-CHECKOUT-CART") return oldNode;
    if (newNode.tagName !== oldNode.tagName) return newNode;
    const newKey = getNodeKey(newNode, options);
    const oldKey = getNodeKey(oldNode, options);
    if (newKey && oldKey && newKey !== oldKey) return newNode;
  }
  if (oldNode instanceof Element && oldNode.hasAttribute("data-skip-node-update") && newNode instanceof Element && newNode.hasAttribute("data-skip-node-update")) {
    updateChildren(newNode, oldNode, options);
  } else {
    updateNode(newNode, oldNode, options);
    updateChildren(newNode, oldNode, options);
  }
  (_b = options.onAfterUpdate) == null ? void 0 : _b.call(options, newNode);
  return oldNode;
}
function updateNode(newNode, oldNode, options) {
  var _a;
  (_a = options.onBeforeUpdate) == null ? void 0 : _a.call(options, oldNode, newNode);
  if (newNode instanceof HTMLDetailsElement && oldNode instanceof HTMLDetailsElement || newNode instanceof HTMLDialogElement && oldNode instanceof HTMLDialogElement) {
    if (!newNode.hasAttribute("declarative-open")) {
      if (!newNode.closest("accordion-component")) {
        newNode.open = oldNode.open;
      }
    }
  }
  if (oldNode instanceof HTMLElement && newNode instanceof HTMLElement) {
    for (const attr of ["slot", "sizes"]) {
      const oldValue = oldNode.getAttribute(attr);
      const newValue = newNode.getAttribute(attr);
      if (oldValue !== newValue) {
        oldValue == null ? newNode.removeAttribute(attr) : newNode.setAttribute(attr, oldValue);
      }
    }
  }
  if (newNode instanceof Element && oldNode instanceof Element) {
    if (!oldNode.isEqualNode(newNode)) {
      copyAttributes(newNode, oldNode);
    }
  } else if (newNode instanceof Text || newNode instanceof Comment) {
    if (oldNode.nodeValue !== newNode.nodeValue) {
      oldNode.nodeValue = newNode.nodeValue;
    }
  }
  if (newNode instanceof HTMLInputElement && oldNode instanceof HTMLInputElement) {
    updateInput(newNode, oldNode);
  } else if (newNode instanceof HTMLOptionElement && oldNode instanceof HTMLOptionElement) {
    updateAttribute(newNode, oldNode, "selected");
  } else if (newNode instanceof HTMLTextAreaElement && oldNode instanceof HTMLTextAreaElement) {
    updateTextarea(newNode, oldNode);
  }
}
function getNodeKey(node, options) {
  var _a;
  return ((_a = options == null ? void 0 : options.getNodeKey) == null ? void 0 : _a.call(options, node)) ?? (node instanceof Element ? node.id : void 0);
}
function updateAttribute(newNode, oldNode, name) {
  if (newNode[name] !== oldNode[name]) {
    oldNode[name] = newNode[name];
    if (newNode[name] != null) {
      oldNode.setAttribute(name, "");
    } else {
      oldNode.removeAttribute(name);
    }
  }
}
function copyAttributes(newNode, oldNode) {
  const oldAttrs = oldNode.attributes;
  const newAttrs = newNode.attributes;
  for (const attr of Array.from(newAttrs)) {
    const { name: attrName, namespaceURI: attrNamespaceURI, value: attrValue } = attr;
    const localName = attr.localName || attrName;
    if (attrName === "src" || attrName === "href" || attrName === "srcset" || attrName === "poster") {
      if (oldNode.getAttribute(attrName) === attrValue) continue;
    }
    if (attrNamespaceURI) {
      const fromValue = oldNode.getAttributeNS(attrNamespaceURI, localName);
      if (fromValue !== attrValue) {
        oldNode.setAttributeNS(attrNamespaceURI, localName, attrValue);
      }
    } else {
      if (!oldNode.hasAttribute(attrName)) {
        oldNode.setAttribute(attrName, attrValue);
      } else {
        const fromValue = oldNode.getAttribute(attrName);
        if (fromValue !== attrValue) {
          if (attrValue === "null" || attrValue === "undefined") {
            oldNode.removeAttribute(attrName);
          } else {
            oldNode.setAttribute(attrName, attrValue);
          }
        }
      }
    }
  }
  for (const attr of Array.from(oldAttrs)) {
    if (attr.specified === false) continue;
    const { name: attrName, namespaceURI: attrNamespaceURI } = attr;
    const localName = attr.localName || attrName;
    if (attrNamespaceURI) {
      if (!newNode.hasAttributeNS(attrNamespaceURI, localName)) {
        oldNode.removeAttributeNS(attrNamespaceURI, localName);
      }
    } else if (!newNode.hasAttribute(attrName)) {
      oldNode.removeAttribute(attrName);
    }
  }
}
function updateInput(newNode, oldNode) {
  const newValue = newNode.value;
  updateAttribute(newNode, oldNode, "checked");
  updateAttribute(newNode, oldNode, "disabled");
  if (newNode.indeterminate !== oldNode.indeterminate) {
    oldNode.indeterminate = newNode.indeterminate;
  }
  if (oldNode.type === "file") return;
  if (newValue !== oldNode.value) {
    oldNode.setAttribute("value", newValue);
    oldNode.value = newValue;
  }
  if (newValue === "null") {
    oldNode.value = "";
    oldNode.removeAttribute("value");
  }
  if (!newNode.hasAttributeNS(null, "value")) {
    oldNode.removeAttribute("value");
  } else if (oldNode.type === "range") {
    oldNode.value = newValue;
  }
}
function updateTextarea(newNode, oldNode) {
  const newValue = newNode.value;
  if (newValue !== oldNode.value) {
    oldNode.value = newValue;
  }
  const firstChild = oldNode.firstChild;
  if ((firstChild == null ? void 0 : firstChild.nodeType) === Node.TEXT_NODE) {
    if (newValue === "" && firstChild.nodeValue === oldNode.placeholder) {
      return;
    }
    firstChild.nodeValue = newValue;
  }
}
function updateChildren(newNode, oldNode, options) {
  var _a;
  if (oldNode instanceof Element && oldNode.hasAttribute("data-skip-subtree-update") && newNode instanceof Element && newNode.hasAttribute("data-skip-subtree-update")) {
    return;
  }
  let oldChild, newChild, morphed, oldMatch;
  let offset = 0;
  for (let i = 0; ; i++) {
    oldChild = oldNode.childNodes[i];
    newChild = newNode.childNodes[i - offset];
    if (!oldChild && !newChild) {
      break;
    }
    if (!newChild) {
      oldChild && oldNode.removeChild(oldChild);
      i--;
      continue;
    }
    if (!oldChild) {
      oldNode.appendChild(newChild);
      offset++;
      continue;
    }
    if (same(newChild, oldChild, options)) {
      morphed = walk(newChild, oldChild, options);
      if (morphed !== oldChild) {
        oldNode.replaceChild(morphed, oldChild);
        offset++;
      }
      continue;
    }
    if ((_a = options.reject) == null ? void 0 : _a.call(options, oldChild, newChild)) {
      newNode.removeChild(newChild);
      i--;
      continue;
    }
    oldMatch = null;
    for (let j = i; j < oldNode.childNodes.length; j++) {
      const potentialOldNode = oldNode.childNodes[j];
      if (potentialOldNode && same(potentialOldNode, newChild, options)) {
        oldMatch = potentialOldNode;
        break;
      }
    }
    if (oldMatch) {
      morphed = walk(newChild, oldMatch, options);
      if (morphed !== oldMatch) offset++;
      oldNode.insertBefore(morphed, oldChild);
    } else if (!getNodeKey(newChild, options) && !getNodeKey(oldChild, options)) {
      morphed = walk(newChild, oldChild, options);
      if (morphed !== oldChild) {
        oldNode.replaceChild(morphed, oldChild);
        offset++;
      }
    } else {
      oldNode.insertBefore(newChild, oldChild);
      offset++;
    }
  }
}
function same(a, b, options) {
  var _a, _b;
  if (a.nodeType !== b.nodeType) return false;
  if (a.nodeType === Node.ELEMENT_NODE) {
    if (a instanceof Element && b instanceof Element && a.tagName !== b.tagName) return false;
    const aKey = getNodeKey(a, options);
    const bKey = getNodeKey(b, options);
    if (aKey && bKey && aKey !== bKey) return false;
  }
  if (a.nodeType === Node.TEXT_NODE && b.nodeType === Node.TEXT_NODE)
    return ((_a = a.nodeValue) == null ? void 0 : _a.trim()) === ((_b = b.nodeValue) == null ? void 0 : _b.trim());
  if (a.nodeType === Node.COMMENT_NODE && b.nodeType === Node.COMMENT_NODE) return a.nodeValue === b.nodeValue;
  return true;
}
class SectionRenderer {
  constructor() {
    __privateAdd(this, _SectionRenderer_instances);
    /**
     * The cache of section HTML
     * @type {Map<string, string>}
     */
    __privateAdd(this, _cache, /* @__PURE__ */ new Map());
    /**
     * The abort controllers by section ID
     * @type {Map<string, AbortController>}
     */
    __privateAdd(this, _abortControllersBySectionId, /* @__PURE__ */ new Map());
    /**
     * The pending promises
     * @type {Map<string, Promise<string>>}
     */
    __privateAdd(this, _pendingPromises, /* @__PURE__ */ new Map());
    if (document.readyState === "complete") {
      __privateMethod(this, _SectionRenderer_instances, cachePageSections_fn).call(this);
    } else {
      window.addEventListener("load", __privateMethod(this, _SectionRenderer_instances, cachePageSections_fn).bind(this));
    }
  }
  /**
   * Renders a section
   * @param {string} sectionId - The section ID
   * @param {Object} [options] - The options
   * @param {boolean} [options.cache] - Whether to use the cache
   * @param {URL} [options.url] - The URL to render the section for
   * @returns {Promise<string>} The rendered section HTML
   */
  async renderSection(sectionId, options) {
    const { cache = !Shopify.designMode, url = new URL(window.location.href) } = options ?? {};
    __privateMethod(this, _SectionRenderer_instances, abortPendingMorph_fn).call(this, sectionId);
    const abortController = new AbortController();
    __privateGet(this, _abortControllersBySectionId).set(sectionId, abortController);
    const sectionHTML = await this.getSectionHTML(sectionId, cache, url);
    if (!abortController.signal.aborted) {
      __privateGet(this, _abortControllersBySectionId).delete(sectionId);
      morphSection(sectionId, sectionHTML);
    }
    return sectionHTML;
  }
  /**
   * Gets the HTML for a section
   * @param {string} sectionId - The section ID
   * @param {boolean} useCache - Whether to use the cache
   * @param {URL} url - The URL to render the section for
   * @returns {Promise<string>} The rendered section HTML
   */
  async getSectionHTML(sectionId, useCache = true, url = new URL(window.location.href)) {
    const sectionUrl = buildSectionRenderingURL(sectionId, url);
    let pendingPromise = __privateGet(this, _pendingPromises).get(sectionUrl);
    if (pendingPromise) return pendingPromise;
    if (useCache) {
      const cachedHTML = __privateGet(this, _cache).get(sectionUrl);
      if (cachedHTML) return cachedHTML;
    }
    pendingPromise = fetch(sectionUrl).then((response) => {
      return response.text();
    });
    __privateGet(this, _pendingPromises).set(sectionUrl, pendingPromise);
    const sectionHTML = await pendingPromise;
    __privateGet(this, _pendingPromises).delete(sectionUrl);
    __privateGet(this, _cache).set(sectionUrl, sectionHTML);
    return sectionHTML;
  }
}
_cache = new WeakMap();
_abortControllersBySectionId = new WeakMap();
_pendingPromises = new WeakMap();
_SectionRenderer_instances = new WeakSet();
/**
 * Aborts an existing morph for a section
 * @param {string} sectionId - The section ID
 */
abortPendingMorph_fn = function(sectionId) {
  const existingAbortController = __privateGet(this, _abortControllersBySectionId).get(sectionId);
  if (existingAbortController) {
    existingAbortController.abort();
  }
};
/**
 * Caches the page sections
 */
cachePageSections_fn = function() {
  for (const section of document.querySelectorAll(".shopify-section")) {
    const url = buildSectionRenderingURL(section.id);
    if (__privateGet(this, _cache).get(url)) return;
    if (containsShadowRoot(section)) return;
    __privateGet(this, _cache).set(url, section.outerHTML);
  }
};
const SECTION_ID_PREFIX = "shopify-section-";
function buildSectionRenderingURL(sectionId, url = new URL(window.location.href)) {
  url.searchParams.set("section_id", normalizeSectionId(sectionId));
  url.searchParams.sort();
  return url.toString();
}
function buildSectionSelector(sectionId) {
  return `${SECTION_ID_PREFIX}${sectionId}`;
}
function normalizeSectionId(sectionId) {
  return sectionId.replace(new RegExp(`^${SECTION_ID_PREFIX}`), "");
}
function containsShadowRoot(element) {
  return !!element.shadowRoot || Array.from(element.children).some(containsShadowRoot);
}
async function morphSection(sectionId, html) {
  const fragment = new DOMParser().parseFromString(html, "text/html");
  const deferredTemplates = fragment.querySelectorAll(
    "template.deferred-cart-content, template.deferred-cart-footer, template.deferred-cart-subdrawer"
  );
  deferredTemplates.forEach((tpl) => {
    const tplFragment = document.createDocumentFragment();
    tplFragment.append(...tpl.content.childNodes);
    tpl.replaceWith(tplFragment);
  });
  const existingElement = document.getElementById(buildSectionSelector(sectionId));
  const newElement = fragment.getElementById(buildSectionSelector(sectionId));
  if (!existingElement) {
    throw new Error(`Section ${sectionId} not found`);
  }
  if (!newElement) {
    throw new Error(`Section ${sectionId} not found in the section rendering response`);
  }
  const oldScripts = collectScriptSignatures(existingElement);
  const morphResult = morph(existingElement, newElement, {
    ...MORPH_OPTIONS,
    onAfterUpdate(node) {
      var _a;
      (_a = MORPH_OPTIONS.onAfterUpdate) == null ? void 0 : _a.call(MORPH_OPTIONS, node);
    }
  });
  lazyReveal(morphResult);
  if (hasInteracted()) {
    activateInteractionAssets(morphResult);
  }
  executeNewScripts(existingElement, oldScripts);
}
function collectScriptSignatures(root) {
  var _a, _b;
  const signatures = /* @__PURE__ */ new Set();
  (_b = (_a = root.querySelectorAll) == null ? void 0 : _a.call(root, "script")) == null ? void 0 : _b.forEach((script) => {
    const sig = getScriptSignature(script);
    if (sig) signatures.add(sig);
  });
  return signatures;
}
function getScriptSignature(script) {
  var _a;
  if (script.src) return script.src;
  const text = (_a = script.textContent) == null ? void 0 : _a.trim();
  return text ?? "";
}
function executeNewScripts(root, oldScripts) {
  var _a;
  const scripts = Array.from(((_a = root.querySelectorAll) == null ? void 0 : _a.call(root, "script")) ?? []);
  for (const old of scripts) {
    const sig = getScriptSignature(old);
    if (!sig || oldScripts.has(sig)) continue;
    const fresh = document.createElement("script");
    for (const attr of old.attributes) {
      fresh.setAttribute(attr.name, attr.value);
    }
    fresh.textContent = old.textContent;
    old.replaceWith(fresh);
  }
}
const sectionRenderer = new SectionRenderer();
class CustomEvents {
}
__publicField(CustomEvents, "cartUpdate", "cart:update");
__publicField(CustomEvents, "cartNoteUpdate", "cart-note:close");
__publicField(CustomEvents, "quantitySelectorUpdate", "quantity-selector:update");
__publicField(CustomEvents, "discountUpdate", "discount:update");
__publicField(CustomEvents, "variantPickerSelected", "variant-picker:selected");
__publicField(CustomEvents, "variantPickerUpdate", "variant-picker:update");
__publicField(CustomEvents, "FilterUpdate", "filter:update");
__publicField(CustomEvents, "themeAlertOpen", "theme-alert:open");
__publicField(CustomEvents, "cartSectionsToUpdate", "cart:sections-to-update");
__publicField(CustomEvents, "subDrawerOpen", "sub-drawer:open");
/** @static @constant {string} Event triggered when a media (video, 3d model) is loaded */
__publicField(CustomEvents, "mediaStartedPlaying", "media:started-playing");
__publicField(CustomEvents, "cartError", "cart:error");
class SubDrawerOpenEvent extends Event {
  constructor(targetId, trigger) {
    super(CustomEvents.subDrawerOpen, { bubbles: true });
    this.detail = { targetId, trigger };
  }
}
class CartNoteUpdateEvent extends Event {
  constructor() {
    super(CustomEvents.cartNoteUpdate, { bubbles: true });
  }
}
class ThemeAlertOpenEvent extends Event {
  constructor(text, state) {
    super(CustomEvents.themeAlertOpen, { bubbles: true });
    this.detail = {
      text: text || null,
      state: state || null
    };
  }
}
class VariantPickerSelectedEvent extends Event {
  constructor(resource, data) {
    super(CustomEvents.variantPickerSelected, { bubbles: true });
    this.detail = {
      resource,
      data
    };
  }
}
class VariantPickerUpdateEvent extends Event {
  constructor(resource, sourceId, data) {
    super(CustomEvents.variantPickerUpdate, { bubbles: true });
    this.detail = {
      resource: resource || null,
      sourceId,
      data: {
        html: data.html,
        productId: data.productId,
        newProduct: data.newProduct
      }
    };
  }
}
const _CartAddEvent = class _CartAddEvent extends Event {
  constructor(resource, sourceId, data) {
    super(_CartAddEvent.eventName, { bubbles: true });
    this.detail = {
      resource,
      sourceId,
      data: {
        ...data
      }
    };
  }
};
__publicField(_CartAddEvent, "eventName", CustomEvents.cartUpdate);
let CartAddEvent = _CartAddEvent;
class CartUpdateEvent extends Event {
  constructor(resource, sourceId, data) {
    super(CustomEvents.cartUpdate, { bubbles: true });
    this.detail = {
      resource,
      sourceId,
      data: {
        ...data
      }
    };
  }
}
class QuantitySelectorUpdateEvent extends Event {
  constructor(quantity, cartLine) {
    super(CustomEvents.quantitySelectorUpdate, { bubbles: true });
    this.detail = {
      quantity,
      cartLine
    };
  }
}
class DiscountUpdateEvent extends Event {
  constructor(resource, sourceId) {
    super(CustomEvents.discountUpdate, { bubbles: true });
    this.detail = {
      resource,
      sourceId
    };
  }
}
class FilterUpdateEvent extends Event {
  /** @param {URLSearchParams} queryParams */
  constructor(queryParams) {
    super(CustomEvents.FilterUpdate, { bubbles: true });
    this.detail = {
      queryParams
    };
  }
  shouldShowClearAll() {
    return [...this.detail.queryParams.entries()].filter(([key]) => key.startsWith("filter.")).length > 0;
  }
}
class MediaStartedPlayingEvent extends Event {
  /**
   * Creates a new MediaStartedPlayingEvent
   * @param {HTMLElement} resource - The element containing the video that emitted the event
   */
  constructor(resource) {
    super(CustomEvents.mediaStartedPlaying, { bubbles: true });
    this.detail = {
      resource
    };
  }
}
class CartErrorEvent extends Event {
  constructor(message, errors, sourceId) {
    super(CustomEvents.cartError, { bubbles: true });
    this.detail = {
      message,
      errors,
      sourceId
    };
  }
}
const trapFocusHandlers = {};
let previouslyFocused = null;
let lastInteractionType = "mouse";
if (typeof window !== "undefined") {
  const idleCb = typeof requestIdleCallback === "function" ? requestIdleCallback : setTimeout;
  idleCb(() => {
    window.addEventListener("keydown", () => {
      lastInteractionType = "keyboard";
    }, { capture: true, passive: true });
    window.addEventListener("mousedown", () => {
      lastInteractionType = "mouse";
    }, { capture: true, passive: true });
    window.addEventListener("touchstart", () => {
      lastInteractionType = "mouse";
    }, { capture: true, passive: true });
  });
}
function isKeyboardUser() {
  return lastInteractionType === "keyboard";
}
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
function trapFocus(container, elementToFocus) {
  removeTrapFocus();
  previouslyFocused = /** @type {HTMLElement | null} */
  document.activeElement;
  const focusable = getFocusableElements(container);
  if (!focusable.length) {
    return;
  }
  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  trapFocusHandlers.keydown = (event) => {
    if (event.key !== "Tab") return;
    const activeEl = document.activeElement;
    if (!event.shiftKey && activeEl === last) {
      event.preventDefault();
      first == null ? void 0 : first.focus();
    } else if (event.shiftKey && (activeEl === first || activeEl === container)) {
      event.preventDefault();
      last == null ? void 0 : last.focus();
    }
  };
  trapFocusHandlers.focusin = (event) => {
    if (event.target instanceof Node && !container.contains(event.target)) {
      event.stopPropagation();
      first == null ? void 0 : first.focus();
    }
  };
  document.addEventListener("keydown", trapFocusHandlers.keydown, true);
  document.addEventListener("focusin", trapFocusHandlers.focusin, true);
  if (isKeyboardUser()) {
    container.focus();
  }
}
function removeTrapFocus() {
  trapFocusHandlers.keydown && document.removeEventListener("keydown", trapFocusHandlers.keydown, true);
  trapFocusHandlers.focusin && document.removeEventListener("focusin", trapFocusHandlers.focusin, true);
  if (previouslyFocused && previouslyFocused.focus) {
    previouslyFocused.focus({ preventScroll: true });
  }
  previouslyFocused = null;
}
export {
  isTouchDevice as $,
  isDesktop as A,
  isTablet as B,
  Component as C,
  DiscountUpdateEvent as D,
  isClickedOutside as E,
  FilterUpdateEvent as F,
  isKeyboardUser as G,
  getBaseFontSize as H,
  findOptimalFontSize as I,
  morph as J,
  setInnerHTML as K,
  onDocumentLoaded as L,
  MediaStartedPlayingEvent as M,
  CartErrorEvent as N,
  CartAddEvent as O,
  addNumberPagination as P,
  addThumbButtonClickHandlers as Q,
  ResizeNotifier as R,
  addToggleThumbButtonsActive as S,
  ThemeAlertOpenEvent as T,
  QuantitySelectorUpdateEvent as U,
  formatMoney as V,
  remToPx as W,
  addBarsBtnsAndClickHandlersSSR as X,
  trapFocus as Y,
  removeTrapFocus as Z,
  SubDrawerOpenEvent as _,
  addPrevNextBtnsClickHandlersSSR as a,
  VariantPickerSelectedEvent as a0,
  VariantPickerUpdateEvent as a1,
  addAutoplayProgressListeners as a2,
  addAutoplayProgressDotListeners as a3,
  DeclarativeShadowElement as a4,
  MORPH_OPTIONS as a5,
  addDotsBtnsAndClickHandlersSSR as b,
  addInstagramDotBtnsAndClickHandlers as c,
  debounce as d,
  extractSlideColorSchemes as e,
  duplicateSlidesForLoop as f,
  addLayoutShiftPrevention as g,
  addColorSchemeSyncHandlers as h,
  isMobile as i,
  fetchConfig as j,
  CustomEvents as k,
  lazyInit as l,
  morphSection as m,
  hasInteracted as n,
  onFirstInteractionIdle as o,
  onFirstInteraction as p,
  activateInteractionAssets as q,
  prefersReducedMotion as r,
  sectionRenderer as s,
  lazyReveal as t,
  onAnimationEnd as u,
  CartUpdateEvent as v,
  resetShimmer as w,
  CartNoteUpdateEvent as x,
  getCookie as y,
  setCookie as z
};
